import AuthPageLayout from './AuthPageLayout';

export default AuthPageLayout;
